import React, { createContext } from 'react';
import withSizes from 'react-sizes';
import { MOBILE, TABLET } from '../utils/responsiveUtils';

const initialContext = {
  isMobile: false,
  isTablet: false,
  isDesktop: false,
  hideNavLabels: false,
  landingPageWidgetBreak: false,
  changeSummaryLayout: false,
  changePaymentLayout: false,
  changeDriverInfraction: false,
  changePaymentPlansToMobile: false,
};

export const GlobalStateContext = createContext(initialContext);

const GlobalStateProvider = ({
  children,
  isMobile,
  isTablet,
  isDesktop,
  hideNavLabels,
  changeSummaryLayout,
  changePaymentLayout,
  changeDriverInfraction,
  changePaymentPlansToMobile,
}) => {
  return (
    <GlobalStateContext.Provider
      value={{
        isMobile,
        isTablet,
        isDesktop,
        hideNavLabels,
        changeSummaryLayout,
        changePaymentLayout,
        changeDriverInfraction,
        changePaymentPlansToMobile,
      }}
    >
      {children}
    </GlobalStateContext.Provider>
  );
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width <= MOBILE,
  isTablet: width <= TABLET && width > MOBILE,
  isDesktop: width > TABLET,
  hideNavLabels: width < 600,
  changeSummaryLayout: width < 660,
  changePaymentLayout: width < 500,
  changeDriverInfraction: width < 860,
  changePaymentPlansToMobile: width < 910,
});

export default withSizes(mapSizesToProps)(GlobalStateProvider);
